import React from "react";

import type { PaymentMethodsModel } from "@stepapp/core/apiTypes";
import { Block } from "@stepapp/ui";

import PaymentOption from "./PaymentOption";

type Props = {
  cards: PaymentMethodsModel[];
  onCardPress: (cardId: string) => void;
};

const Cards = ({ onCardPress, cards }: Props) => {
  return (
    <Block marginTop={2} paddingBottom={1}>
      {cards.map((card) => (
        <Block key={card.id}>
          <PaymentOption
            icon="close"
            key={card.id}
            label={`${card.last4}`}
            onPress={() => onCardPress(card.id)}
            type={card?.brand?.toLowerCase?.() as "visa"}
          />
        </Block>
      ))}
    </Block>
  );
};

export default React.memo(Cards);
